import axios from 'axios';
import {
  FETCH_ADDRESS_SUCCESS,
  FETCH_ADDRESS_FAIL,
  CREATE_ADDRESS_SUCCESS,
  CREATE_ADDRESS_FAIL,
  WITHDRAW_FUNDS_SUCCESS,
  WITHDRAW_FUNDS_FAIL,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_FAIL,
  FETCH_WITHDRAWAL_FEES_SUCCESS,
  FETCH_WITHDRAWAL_FEES_FAIL,
  APPROVE_WITHDRAWAL_SUCCESS,
  APPROVE_WITHDRAWAL_FAIL,
  DENY_WITHDRAWAL_SUCCESS,
  DENY_WITHDRAWAL_FAIL,
  FETCH_APPROVALS_SUCCESS,
  FETCH_APPROVALS_FAIL,
} from './types';

export const fetchAddress = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/address';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_ADDRESS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_ADDRESS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_ADDRESS_FAIL });
  }
};

export const createAddress = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/address';
  try {
    const response = await axios.post(url, null, { params });
    return dispatch({ type: CREATE_ADDRESS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_ADDRESS_FAIL, errors: error });
    }

    return dispatch({ type: CREATE_ADDRESS_FAIL });
  }
};

export const withdrawFunds = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/withdraw';
  try {
    const response = await axios.post(url, null, { params });
    return dispatch({ type: WITHDRAW_FUNDS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: WITHDRAW_FUNDS_FAIL, errors: error });
    }

    return dispatch({ type: WITHDRAW_FUNDS_FAIL });
  }
};

export const fetchTransactions = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/transactions';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_TRANSACTIONS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_TRANSACTIONS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_TRANSACTIONS_FAIL });
  }
};

export const fetchWithdrawalFees = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/withdraw/fees';
  try {
    const response = await axios.post(url, null, { params });
    return dispatch({ type: FETCH_WITHDRAWAL_FEES_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_WITHDRAWAL_FEES_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_WITHDRAWAL_FEES_FAIL });
  }
};

export const approveWithdrawal = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/withdraw/approval';
  try {
    const response = await axios.post(url, null, { params });
    return dispatch({ type: APPROVE_WITHDRAWAL_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: APPROVE_WITHDRAWAL_FAIL, errors: error });
    }
    return dispatch({ type: APPROVE_WITHDRAWAL_FAIL });
  }
};

export const denyWithdrawal = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/withdraw/approval';
  try {
    const response = await axios.delete(url, { params });
    return dispatch({ type: DENY_WITHDRAWAL_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DENY_WITHDRAWAL_FAIL, errors: error });
    }
    return dispatch({ type: DENY_WITHDRAWAL_FAIL });
  }
};

export const fetchApprovals = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/coins/withdraw/approval';
  try {
    const response = await axios.get(url, null, { params });
    return dispatch({ type: FETCH_APPROVALS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_APPROVALS_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_APPROVALS_FAIL });
  }
};
